import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import ContactUs from './components/ContactUs';
import Careers from './components/Careers';
import PrivacyNotice from './components/PrivacyNotice';
import SecurityPolicy from './components/SecurityPolicy';
import CustomizeCookies from './components/CustomizeCookies';
import Disclaimer from './components/Disclaimer';
import CookiePolicy from './components/CookiePolicy';



const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={AboutUs} />
          <Route path="/services" component={Services} />
          <Route path="/careers" component={Careers} />
          <Route path="/contact" component={ContactUs} />
          <Route path="/privacy-notice" component={PrivacyNotice} />
          <Route path="/security-policy" component={SecurityPolicy} />
          <Route path="/customize-cookies" component={CustomizeCookies} />
          <Route path="/disclaimer" component={Disclaimer} />
          <Route path="/cookie-policy" component={CookiePolicy} />
        </Switch>
      </div>
    </Router>
  );
};

export default App;